import { Button, Modal } from 'shared/components/ui';
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../../core/context/AuthContext';
import { useFacturacionTecnicos } from '../../hooks/useFacturacionTecnicos';
import { useFacturacionMedicos } from '../../hooks/useFacturacionMedicos';
import { facturacionTecnicosAPI } from '../../services/facturacionTecnicosAPI';
import { facturacionMedicosAPI } from '../../services/facturacionMedicosAPI';
import api from '../../../../core/api/api';
import { exportToExcel } from '../../utils/excelTecnicosUtils';
import { Loading } from '../../../../shared/components';
import { ToastContainer } from '../../../../shared/components/Toast';
import Header from '../../../../shared/components/layout/Header';
import Footer from '../../../../shared/components/layout/Footer';
import TablaFacturacionTecnicos from '../TablaFacturacionTecnicos';
import NotificacionesPanel from '../NotificacionesPanel';
import './FacturacionTecnicos.css';

const FacturacionTecnicos = () => {
  const { user } = useAuth();
  const {
    loading: loadingTecnicos,
    turnos: turnosTecnicos,
    turnosDetalle: turnosDetalleTecnicos,
    setTurnosDetalle: setTurnosDetalleTecnicos,
    notificaciones: notificacionesTecnicos,
    estadoFacturacion: estadoFacturacionTecnicos,
    setEstadoFacturacion: setEstadoFacturacionTecnicos,
    totales: totalesTecnicos,
    setTotales: setTotalesTecnicos,
    isAdmin,
    cargarFacturacion: cargarFacturacionTecnicos,
    cargarDetalle: cargarDetalleTecnicos,
    cargarNotificaciones: cargarNotificacionesTecnicos,
    subirFactura: subirFacturaTecnicos,
    subirComprobante: subirComprobanteTecnicos,
    enviarNotificacion: enviarNotificacionTecnicos
  } = useFacturacionTecnicos();

  const {
    loading: loadingMedicos,
    turnos: turnosMedicos,
    turnosDetalle: turnosDetalleMedicos,
    setTurnosDetalle: setTurnosDetalleMedicos,
    notificaciones: notificacionesMedicos,
    estadoFacturacion: estadoFacturacionMedicos,
    setEstadoFacturacion: setEstadoFacturacionMedicos,
    totales: totalesMedicos,
    setTotales: setTotalesMedicos,
    cargarFacturacion: cargarFacturacionMedicos,
    cargarDetalle: cargarDetalleMedicos,
    cargarNotificaciones: cargarNotificacionesMedicos,
    subirFactura: subirFacturaMedicos,
    subirComprobante: subirComprobanteMedicos,
    enviarNotificacion: enviarNotificacionMedicos
  } = useFacturacionMedicos();

  const [mes, setMes] = useState(new Date().getMonth() === 0 ? 12 : new Date().getMonth());
  const [anio, setAnio] = useState(new Date().getMonth() === 0 ? new Date().getFullYear() - 1 : new Date().getFullYear());
  const [tecnicoSeleccionado, setTecnicoSeleccionado] = useState('');
  const [medicoSeleccionado, setMedicoSeleccionado] = useState('');
  const [tecnicos, setTecnicos] = useState([]);
  const [medicos, setMedicos] = useState([]);
  const [mostrarDetalle, setMostrarDetalle] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const esMedico = user?.role === 'Medico' || user?.role === 'MEDICO' || 
                   user?.roles?.includes('MEDICO') || user?.roles?.includes('Medico');
  const [vistaActiva, setVistaActiva] = useState(
    !isAdmin && esMedico ? 'facturacion-medicos' : 'facturacion-tecnicos'
  );
  const [turnosEditados, setTurnosEditados] = useState([]);
  const [cicloIniciado, setCicloIniciado] = useState(null);
  const [mesBuscado, setMesBuscado] = useState(null);
  const [anioBuscado, setAnioBuscado] = useState(null);
  const [busquedaRealizada, setBusquedaRealizada] = useState(false);
  const [toast, setToast] = useState(null);
  const [mostrarModalAdjuntos, setMostrarModalAdjuntos] = useState(false);
  const [archivoSeleccionado, setArchivoSeleccionado] = useState(null);
  const [mostrarModalSubida, setMostrarModalSubida] = useState(false);
  const [tipoSubida, setTipoSubida] = useState(null);
  const [liquidacionSubida, setLiquidacionSubida] = useState(null);
  const [estadosTurno, setEstadosTurno] = useState([]);
  const [facturandoTodo, setFacturandoTodo] = useState(false);

  useEffect(() => {
    if (isAdmin) {
      cargarTecnicos();
      cargarMedicos();
      cargarEstadosTurno();
    }
  }, [isAdmin]);

  const cargarEstadosTurno = async () => {
    try {
      const response = await api.get('/EstadosTurno/ListarEstadosTurno');
      setEstadosTurno(response.data || []);
    } catch (error) {
      console.error('Error al cargar estados de turno:', error);
    }
  };

  const cargarTecnicos = async () => {
    try {
      const data = await facturacionTecnicosAPI.getTecnicos();
      setTecnicos(data || []);
    } catch (error) {
      console.error('Error al cargar técnicos:', error);
    }
  };

  const cargarMedicos = async () => {
    try {
      const data = await facturacionMedicosAPI.getMedicos();
      setMedicos(data || []);
    } catch (error) {
      console.error('Error al cargar médicos:', error);
    }
  };

  const esTecnicos = () => vistaActiva.includes('tecnicos');
  const loading = esTecnicos() ? loadingTecnicos : loadingMedicos;
  const turnos = esTecnicos() ? turnosTecnicos : turnosMedicos;
  const turnosDetalle = esTecnicos() ? turnosDetalleTecnicos : turnosDetalleMedicos;
  const setTurnosDetalle = esTecnicos() ? setTurnosDetalleTecnicos : setTurnosDetalleMedicos;
  const notificaciones = esTecnicos() ? notificacionesTecnicos : notificacionesMedicos;
  const estadoFacturacion = esTecnicos() ? estadoFacturacionTecnicos : estadoFacturacionMedicos;
  const setEstadoFacturacion = esTecnicos() ? setEstadoFacturacionTecnicos : setEstadoFacturacionMedicos;
  const totales = esTecnicos() ? totalesTecnicos : totalesMedicos;
  const setTotales = esTecnicos() ? setTotalesTecnicos : setTotalesMedicos;
  const cargarFacturacion = esTecnicos() ? cargarFacturacionTecnicos : cargarFacturacionMedicos;
  const cargarDetalle = esTecnicos() ? cargarDetalleTecnicos : cargarDetalleMedicos;
  const cargarNotificaciones = esTecnicos() ? cargarNotificacionesTecnicos : cargarNotificacionesMedicos;
  const subirFactura = esTecnicos() ? subirFacturaTecnicos : subirFacturaMedicos;
  const subirComprobante = esTecnicos() ? subirComprobanteTecnicos : subirComprobanteMedicos;
  const enviarNotificacion = esTecnicos() ? enviarNotificacionTecnicos : enviarNotificacionMedicos;
  const personaSeleccionada = esTecnicos() ? tecnicoSeleccionado : medicoSeleccionado;
  const setPersonaSeleccionada = esTecnicos() ? setTecnicoSeleccionado : setMedicoSeleccionado;
  const personas = esTecnicos() ? tecnicos : medicos;
  const API = esTecnicos() ? facturacionTecnicosAPI : facturacionMedicosAPI;
  const tipoPersona = esTecnicos() ? 'técnico' : 'médico';
  const TipoPersona = esTecnicos() ? 'Técnico' : 'Médico';

  const handleBuscar = async () => {
    if (!mes || !anio) {
      setToast({ message: 'Debe seleccionar mes y año', type: 'error' });
      return;
    }

    try {
      if (vistaActiva === 'facturacion-tecnicos' || vistaActiva === 'facturacion-medicos') {
        let idPersona = isAdmin ? personaSeleccionada : null;
        
        if (!isAdmin) {
          idPersona = user?.idMedico;
        }
        
        if (!idPersona) {
          setToast({ message: isAdmin ? `Debe seleccionar un ${tipoPersona}` : `No se encontró el ID del ${tipoPersona}`, type: 'error' });
          return;
        }

        await cargarDetalle(parseInt(idPersona), parseInt(mes), parseInt(anio));
        setMostrarDetalle(true);

        const envia = isAdmin ? personas.find(p => p.idMedico === parseInt(idPersona))?.medico1 : user?.username;
        const recibe = isAdmin ? 'ADMINISTRADOR' : 'ADMINISTRADOR';
        await cargarNotificaciones(envia, recibe, parseInt(mes), parseInt(anio));
      } else {
        // Para liquidaciones, no se requiere seleccionar persona en liquidaciones-medicos
        const idPersona = (vistaActiva === 'liquidaciones-tecnicos' || !esTecnicos()) ? null : parseInt(personaSeleccionada);
        await cargarFacturacion(idPersona, parseInt(mes), parseInt(anio));
      }
    } catch (error) {
      console.error('Error al buscar:', error);
      setToast({ message: 'Error al cargar la facturación', type: 'error' });
    }
  };

  const handleExportar = () => {
    const datos = mostrarDetalle ? turnosDetalle : turnos;
    const nombreArchivo = `Facturacion_${personaSeleccionada || user?.username}_${anio}_${mes}`;
    exportToExcel(datos, nombreArchivo);
  };

  const handleSubirArchivo = async (files) => {
    try {
      const idEstado = estadoFacturacion?.idEstadoFacturacionTecnico || estadoFacturacion?.idEstadoFacturacionMedico;
      if (!idEstado) {
        setToast({ message: 'No hay estado de facturación disponible', type: 'error' });
        return;
      }

      if (isAdmin) {
        await subirComprobante(files, idEstado);
        const personaNombre = personas.find(p => p.idMedico === parseInt(personaSeleccionada))?.medico1;
        await enviarNotificacion(
          `Se ha realizado el pago de la facturación correspondiente al Mes de ${getMesNombre(mes)} y Año ${anio}`,
          mes,
          anio,
          personaNombre
        );
      } else {
        await subirFactura(files, idEstado);
        await enviarNotificacion(
          `El ${TipoPersona} ${user?.username} adjuntó la Factura Exitosamente`,
          mes,
          anio,
          'ADMINISTRADOR'
        );
      }

      const idPersona = isAdmin ? parseInt(personaSeleccionada) : user?.idMedico;
      const fechaDesde = `${anio}-${String(mes).padStart(2, '0')}-01`;
      const fechaHasta = mes === 12 ? `${anio + 1}-01-01` : `${anio}-${String(mes + 1).padStart(2, '0')}-01`;
      const estado = await API.getEstadoFacturacion(idPersona, fechaDesde, fechaHasta);
      if (estado && estado.length > 0) {
        const estadoOrdenado = estado.sort((a, b) => (b.idEstadoFacturacionTecnico || b.idEstadoFacturacionMedico) - (a.idEstadoFacturacionTecnico || a.idEstadoFacturacionMedico));
        const estadoConAdjuntos = estadoOrdenado.find(e => e.adjuntoFactura || e.adjuntoComprobante);
        setEstadoFacturacion(estadoConAdjuntos || estadoOrdenado[0]);
      }
      setToast({ message: 'Archivo subido exitosamente', type: 'success' });
    } catch (error) {
      console.error('Error al subir archivo:', error);
      setToast({ message: 'Error al subir archivo', type: 'error' });
    }
  };

  const handleEnviarMensaje = async () => {
    if (!mensaje.trim()) return;

    try {
      const destinatario = isAdmin 
        ? personas.find(p => p.idMedico === parseInt(personaSeleccionada))?.medico1 
        : 'ADMINISTRADOR';
      
      await API.createNotificacion(destinatario, parseInt(mes), parseInt(anio), mensaje);
      setMensaje('');
      
      const envia = isAdmin 
        ? personas.find(p => p.idMedico === parseInt(personaSeleccionada))?.medico1 
        : user?.username;
      const recibe = isAdmin ? 'ADMINISTRADOR' : 'ADMINISTRADOR';
      await cargarNotificaciones(envia, recibe, parseInt(mes), parseInt(anio));
      
      setToast({ message: 'Mensaje enviado correctamente', type: 'success' });
    } catch (error) {
      console.error('Error al enviar mensaje:', error);
      setToast({ message: 'Error al enviar el mensaje', type: 'error' });
    }
  };

  const estadosConImporte = ['realizado', 'listo para enviar', 'enviado', 'facturado', 'escoreado', 'escoreado / muestras en carpeta', 'en proceso', 'solicitado'];

  const esEstadoSinImporte = (auditoria) => {
    const lower = auditoria?.toLowerCase() || '';
    return !estadosConImporte.some(e => lower === e);
  };

  const handleCambiarAuditoria = (idTurno, nuevaAuditoria) => {
    const turno = getTurnosConEdiciones().find(t => t.idTurno === idTurno);
    const sinImporte = esEstadoSinImporte(nuevaAuditoria);
    const datos = { auditoria: nuevaAuditoria, estaFacturado: !sinImporte };
    setTurnosEditados(prev => {
      const existe = prev.find(t => t.idTurno === idTurno);
      if (existe) {
        return prev.map(t => t.idTurno === idTurno ? {...t, ...datos} : t);
      }
      return [...prev, {...turno, ...datos}];
    });
  };

  const handleToggleFacturado = (idTurno) => {
    const turno = getTurnosConEdiciones().find(t => t.idTurno === idTurno);
    const nuevoEstado = !turno.estaFacturado;
    setTurnosEditados(prev => {
      const existe = prev.find(t => t.idTurno === idTurno);
      if (existe) {
        return prev.map(t => t.idTurno === idTurno ? {...t, estaFacturado: nuevoEstado} : t);
      }
      return [...prev, {...turno, estaFacturado: nuevoEstado}];
    });
  };

  const handleToggleAll = async () => {
    if (facturandoTodo) return;
    setFacturandoTodo(true);
    
    try {
      const idPersona = isAdmin ? personaSeleccionada : user?.idMedico;
      await API.iniciarCicloFacturacion(parseInt(idPersona), parseInt(mes), parseInt(anio));

      // Primero aplicar cambios de auditoría (solo los que realmente cambiaron)
      const turnosConAuditoria = new Set();
      const turnosConAuditoriaEditada = turnosEditados.filter(t => t.auditoria != null);
      console.log('[handleToggleAll] turnosEditados total:', turnosEditados.length);
      console.log('[handleToggleAll] turnosConAuditoriaEditada:', turnosConAuditoriaEditada.map(t => ({ id: t.idTurno, auditoria: t.auditoria })));
      for (const t of turnosConAuditoriaEditada) {
        const auditoriaValor = t.auditoria || t.estadosTurno?.estadoTurno || '';
        console.log(`[cambiarAuditoria] idTurno: ${t.idTurno}, auditoria: "${auditoriaValor}"`);
        await API.cambiarAuditoria(t.idTurno, auditoriaValor, parseInt(idPersona));
        turnosConAuditoria.add(t.idTurno);
      }

      // Solo enviar al lote los turnos que el usuario modificó
      const idsEditados = new Set(turnosEditados.map(t => t.idTurno));
      const turnosFinales = getTurnosConEdiciones();
      const turnosAFacturar = [...new Set(turnosFinales
        .filter(t => t.estaFacturado && idsEditados.has(t.idTurno))
        .map(t => t.idTurno))];
      const turnosADesmarcar = [...new Set(turnosFinales
        .filter(t => !t.estaFacturado && idsEditados.has(t.idTurno))
        .map(t => t.idTurno))];

      console.log('[handleToggleAll] idsEditados:', [...idsEditados]);
      console.log('[handleToggleAll] turnosConAuditoria:', [...turnosConAuditoria]);
      console.log('[handleToggleAll] turnosAFacturar:', turnosAFacturar);
      console.log('[handleToggleAll] turnosADesmarcar:', turnosADesmarcar);

      if (turnosAFacturar.length > 0) {
        if (esTecnicos()) {
          await API.facturarTurnosLote(turnosAFacturar, true);
        } else {
          await API.facturarTurnosLote(turnosAFacturar, true, parseInt(personaSeleccionada));
        }
      }
      if (turnosADesmarcar.length > 0) {
        if (esTecnicos()) {
          await API.facturarTurnosLote(turnosADesmarcar, false);
        } else {
          await API.facturarTurnosLote(turnosADesmarcar, false, parseInt(personaSeleccionada));
        }
      }
      setCicloIniciado(true);
      setMesBuscado(mes);
      setAnioBuscado(anio);
      setTurnosEditados([]);
      await handleBuscar();
      setToast({ message: 'Facturación enviada correctamente', type: 'success' });
    } catch (error) {
      console.error('Error al facturar turnos:', error);
      setToast({ message: 'Error al facturar los turnos', type: 'error' });
    } finally {
      setFacturandoTodo(false);
    }
  };

  const getTurnosConEdiciones = () => {
    return turnosDetalle.map(turno => {
      const editado = turnosEditados.find(e => e.idTurno === turno.idTurno);
      return editado || turno;
    });
  };

  const getMesNombre = (mesNum) => {
    const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 
                   'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    return meses[mesNum - 1];
  };

  const verificarYBuscar = async () => {
    setTurnosEditados([]);
    setTurnosDetalle([]);
    setTotales({ totalPracticas: 0, totalPracticasPagas: 0, total: 0 });
    setCicloIniciado(null);
    setMesBuscado(null);
    setAnioBuscado(null);
    setBusquedaRealizada(true);
    
    let idPersona = isAdmin ? personaSeleccionada : null;
    
    if (!isAdmin) {
      idPersona = user?.idMedico;
    }
    
    if (!idPersona) {
      setToast({ message: isAdmin ? `Debe seleccionar un ${tipoPersona}` : `No se encontró el ID del ${tipoPersona}`, type: 'error' });
      return;
    }

    if (!mes || !anio) {
      setToast({ message: 'Debe seleccionar mes y año', type: 'error' });
      return;
    }

    try {
      const fechaDesde = `${anio}-${String(mes).padStart(2, '0')}-01`;
      const fechaHasta = mes === 12 ? `${anio + 1}-01-01` : `${anio}-${String(mes + 1).padStart(2, '0')}-01`;
      
      const estadoAPI = esTecnicos() ? facturacionTecnicosAPI : facturacionMedicosAPI;
      const estado = await estadoAPI.getEstadoFacturacion(parseInt(idPersona), fechaDesde, fechaHasta);
      const campoEstado = esTecnicos() ? 'idEstadoFacturacionTecnico' : 'idEstadoFacturacionMedico';

      if (!isAdmin) {
        if (!estado || estado.length === 0 || estado[0][campoEstado] === null) {
          setToast({ message: 'Todavia no fue facturado el mes seleccionado', type: 'info' });
          return;
        }
        await handleBuscar();
        return;
      }
      setCicloIniciado(estado && estado.length > 0 && estado[0][campoEstado] !== null);
      setMesBuscado(mes);
      setAnioBuscado(anio);
      await handleBuscar();
    } catch (error) {
      console.error('Error al verificar estado:', error);
      await handleBuscar();
    }
  };



  const handleVerAdjuntos = (liquidacion, tipo) => {
    const tieneArchivo = tipo === 'factura' ? liquidacion.adjuntoFactura : liquidacion.adjuntoComprobante;
    const idEstado = liquidacion.idEstadoFacturacionTecnico || liquidacion.idEstadoFacturacionMedico;
    
    if (tieneArchivo) {
      const archivo = tipo === 'factura' 
        ? { url: `${process.env.REACT_APP_ADJUNTOS_URL}/Facturas/${liquidacion.adjuntoFactura}`, nombre: liquidacion.adjuntoFactura, tipo: 'Factura', idEstadoFacturacion: idEstado }
        : { url: `${process.env.REACT_APP_ADJUNTOS_URL}/Comprobantes/${liquidacion.adjuntoComprobante}`, nombre: liquidacion.adjuntoComprobante, tipo: 'Comprobante', idEstadoFacturacion: idEstado };
      setArchivoSeleccionado(archivo);
      setMostrarModalAdjuntos(true);
    } else {
      if (tipo === 'factura') {
        setToast({ message: 'No hay factura cargada', type: 'info' });
        return;
      }
      setTipoSubida(tipo);
      setLiquidacionSubida(liquidacion);
      setMostrarModalSubida(true);
    }
  };

  const handleSubirArchivoLiquidacion = async (event) => {
    const files = Array.from(event.target.files);
    if (files.length === 0) return;

    try {
      const idEstado = liquidacionSubida.idEstadoFacturacionTecnico || liquidacionSubida.idEstadoFacturacionMedico;
      console.log('Liquidación seleccionada:', liquidacionSubida);
      console.log('ID Estado:', idEstado);
      console.log('Tipo subida:', tipoSubida);
      
      if (!idEstado) {
        setToast({ message: 'No se encontró el ID de estado de facturación', type: 'error' });
        return;
      }
      
      if (tipoSubida === 'factura') {
        await subirFactura(files, idEstado);
      } else {
        await subirComprobante(files, idEstado);
      }
      setMostrarModalSubida(false);
      await handleBuscar();
      setToast({ message: `${tipoSubida === 'factura' ? 'Factura' : 'Comprobante'} subido correctamente`, type: 'success' });
    } catch (error) {
      console.error('Error al subir archivo:', error);
      console.error('Detalles:', error.response?.data);
      setToast({ message: error.message || 'Error al subir el archivo', type: 'error' });
    }
  };

  const handleEliminarArchivo = async (tipo) => {
    try {
      if (tipo === 'Factura') {
        await API.eliminarFactura(archivoSeleccionado.idEstadoFacturacion);
      } else {
        await API.eliminarComprobante(archivoSeleccionado.idEstadoFacturacion);
      }
      setMostrarModalAdjuntos(false);
      setArchivoSeleccionado(null);
      await handleBuscar();
      setToast({ message: `${tipo} eliminado correctamente`, type: 'success' });
    } catch (error) {
      console.error('Error al eliminar archivo:', error);
      setToast({ message: 'Error al eliminar el archivo', type: 'error' });
    }
  };

  const handleCerrarModalAdjuntos = () => {
    setMostrarModalAdjuntos(false);
    setArchivoSeleccionado(null);
  };

  return (
    <div className="grilla-turnos">
      <Header />
      <div className="main-content">
        <div className="page-header">
          <h2 className="page-title-grilla">{isAdmin ? 'Facturación - Administración' : 'Mi Facturación'}</h2>
          <span className="page-subtitle">Gestión de facturación y liquidaciones</span>
        </div>

        {isAdmin && (
          <div className="tabs-container">
            <button 
              className={`tab-button ${vistaActiva === 'facturacion-tecnicos' ? 'active' : ''}`}
              onClick={() => setVistaActiva('facturacion-tecnicos')}
            >
              Facturación por Técnico
            </button>
            <button 
              className={`tab-button ${vistaActiva === 'liquidaciones-tecnicos' ? 'active' : ''}`}
              onClick={() => setVistaActiva('liquidaciones-tecnicos')}
            >
              Liquidaciones Técnicos
            </button>
            <button 
              className={`tab-button ${vistaActiva === 'facturacion-medicos' ? 'active' : ''}`}
              onClick={() => setVistaActiva('facturacion-medicos')}
            >
              Facturación por Médico
            </button>
            <button 
              className={`tab-button ${vistaActiva === 'liquidaciones-medicos' ? 'active' : ''}`}
              onClick={() => setVistaActiva('liquidaciones-medicos')}
            >
              Liquidaciones Médicos
            </button>
          </div>
        )}

        {(vistaActiva === 'facturacion-tecnicos' || vistaActiva === 'facturacion-medicos') && (
          <>
            <div className="filtros-container">
              {isAdmin && (
                <div className="form-group">
                  <label>{TipoPersona}</label>
                  <select 
                    value={personaSeleccionada} 
                    onChange={(e) => setPersonaSeleccionada(e.target.value)}
                    className="form-control"
                  >
                    <option value="">Seleccione...</option>
                    {personas.map(p => (
                      <option key={p.idMedico} value={p.idMedico}>{p.medico1}</option>
                    ))}
                  </select>
                </div>
              )}

              <div className="form-group">
                <label>Mes</label>
                <select value={mes} onChange={(e) => setMes(parseInt(e.target.value))} className="form-control">
                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>{getMesNombre(i + 1)}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Año</label>
                <select value={anio} onChange={(e) => setAnio(parseInt(e.target.value))} className="form-control">
                  {Array.from({ length: 9 }, (_, i) => 2018 + i).map(y => (
                    <option key={y} value={y}>{y}</option>
                  ))}
                </select>
              </div>

              <div className="form-group button-group">
                <Button onClick={verificarYBuscar} className="btn btn-primary">Buscar</Button>
                <Button onClick={handleExportar} className="btn btn-success" disabled={turnosDetalle.length === 0}>Exportar Excel</Button>
              </div>
            </div>

            {loading && <Loading />}

            {turnosDetalle.length === 0 && busquedaRealizada && !loading && (
              <div style={{ padding: '2rem', textAlign: 'center', color: '#64748b', backgroundColor: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                <h4 style={{ margin: '0 0 8px 0' }}>No se encontraron prácticas</h4>
                <p style={{ margin: 0 }}>No hay prácticas para el período seleccionado.</p>
              </div>
            )}

            {turnosDetalle.length > 0 && (
              <>
                <div className="totales-container">
                <div className="card-total">
                  <h4>Cantidad Prácticas: <strong>{totales.totalPracticas}</strong></h4>
                </div>
                <div className="card-total">
                  <h4>Cantidad Prácticas facturadas: <strong>{getTurnosConEdiciones().filter(t => t.estaFacturado && parseFloat(t.importe || t.importeTecnico || 0) > 0).length}</strong></h4>
                </div>
                <div className="card-total">
                  <h4>Total: <strong>${totales.total}</strong></h4>
                </div>
                <div className="card-total">
                  <h4>Total facturado: <strong>${getTurnosConEdiciones().filter(t => t.estaFacturado).reduce((sum, t) => sum + parseFloat(t.importe || t.importeTecnico || 0), 0).toFixed(2)}</strong></h4>
                </div>
                {isAdmin && (
                  <Button onClick={handleToggleAll} className="btn btn-warning" disabled={facturandoTodo} title={cicloIniciado ? 'Se actualizará la facturación y se notificará al técnico' : 'Se enviará la facturación y se notificará al técnico'}>
                    {facturandoTodo ? 'Enviando...' : cicloIniciado ? 'Actualizar Facturación' : 'Enviar Facturación'}
                  </Button>
                )}
              </div>
              </>
            )}

            {turnosDetalle.length > 0 && isAdmin && cicloIniciado !== null && (
              <div style={{
                display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 16px', borderRadius: '8px', margin: '0 0 12px 0',
                backgroundColor: cicloIniciado ? '#d1fae5' : '#fef3c7',
                border: `1px solid ${cicloIniciado ? '#6ee7b7' : '#fcd34d'}`,
                color: cicloIniciado ? '#065f46' : '#92400e',
                fontSize: '0.9rem'
              }}>
                <span style={{ fontSize: '1.2rem' }}>{cicloIniciado ? '✅' : '⚠️'}</span>
                <span style={{ fontWeight: 600 }}>
                  {cicloIniciado
                    ? `La facturación de ${getMesNombre(mesBuscado)} ${anioBuscado} ya fue enviada al técnico.`
                    : `La facturación de ${getMesNombre(mesBuscado)} ${anioBuscado} aún no fue enviada. Pulse "Enviar Facturación" para facturar el mes y las prácticas seleccionadas.`}
                </span>
              </div>
            )}

            {turnosDetalle.length > 0 && (
              <TablaFacturacionTecnicos 
                datos={getTurnosConEdiciones()}
                titulo="Detalle de Prácticas"
                onToggleFacturado={handleToggleFacturado}
                onToggleAll={handleToggleAll}
                onCambiarAuditoria={handleCambiarAuditoria}
                estadosTurno={estadosTurno}
                isAdmin={isAdmin}
                esMedicos={!esTecnicos()}
                botonesSeleccion={isAdmin && (
                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <Button
                      className="btn btn-success"
                      title="Marca todas las prácticas como facturadas (no envía nada aún)"
                      onClick={() => {
                        const todos = turnosDetalle
                          .filter(t => parseFloat(t.importe || t.importeTecnico || 0) > 0)
                          .map(t => ({...t, estaFacturado: true}));
                        setTurnosEditados(todos);
                      }}
                    >
                      ☑ Seleccionar Todo
                    </Button>
                    <Button
                      className="btn btn-danger"
                      title="Desmarca todas las prácticas (no envía nada aún)"
                      onClick={() => {
                        const todos = turnosDetalle.map(t => ({...t, estaFacturado: false}));
                        setTurnosEditados(todos);
                      }}
                    >
                      ☐ Deseleccionar Todo
                    </Button>
                  </div>
                )}
              />
            )}

            {turnosDetalle.length > 0 && !isAdmin && (
              <div className="upload-container">
                <h3>Subir Factura</h3>
                <p>Estado: {estadoFacturacion?.adjuntoFactura ? 'Factura cargada' : 'Sin factura'}</p>
                {estadoFacturacion?.adjuntoFactura ? (
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <Button
                      className="btn btn-primary" 
                      onClick={() => {
                        setArchivoSeleccionado({
                          url: `${process.env.REACT_APP_ADJUNTOS_URL}/Facturas/${estadoFacturacion.adjuntoFactura}`,
                          nombre: estadoFacturacion.adjuntoFactura,
                          tipo: 'Factura',
                          idEstadoFacturacion: estadoFacturacion.idEstadoFacturacionTecnico || estadoFacturacion.idEstadoFacturacionMedico
                        });
                        setMostrarModalAdjuntos(true);
                      }}
                    >
                      Ver Factura
                    </Button>
                    <Button
                      type="button"
                      className="btn btn-danger" 
                      onClick={async (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        try {
                          const idEstado = estadoFacturacion.idEstadoFacturacionTecnico || estadoFacturacion.idEstadoFacturacionMedico;
                          await API.eliminarFactura(idEstado);
                          const idPersona = user?.idMedico;
                          const fechaDesde = `${anio}-${String(mes).padStart(2, '0')}-01`;
                          const fechaHasta = mes === 12 ? `${anio + 1}-01-01` : `${anio}-${String(mes + 1).padStart(2, '0')}-01`;
                          const estado = await API.getEstadoFacturacion(idPersona, fechaDesde, fechaHasta);
                          if (estado && estado.length > 0) {
                            const ultimoEstado = estado.sort((a, b) => b.idEstadoFacturacionTecnico - a.idEstadoFacturacionTecnico)[0];
                            setEstadoFacturacion(ultimoEstado);
                          }
                          setToast({ message: 'Factura eliminada correctamente', type: 'success' });
                        } catch (error) {
                          console.error('Error al eliminar factura:', error);
                          setToast({ message: 'Error al eliminar la factura', type: 'error' });
                        }
                      }}
                    >
                      Eliminar Factura
                    </Button>
                  </div>
                ) : (
                  <div>
                    <input
                      type="file"
                      className="form-control"
                      onChange={(e) => {
                        e.preventDefault();
                        const files = Array.from(e.target.files);
                        if (files.length > 0) {
                          handleSubirArchivo(files);
                          e.target.value = '';
                        }
                      }}
                      accept=".pdf,.jpg,.jpeg,.png"
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                )}
                <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #e2e8f0' }}>
                  <h4 style={{ marginBottom: '10px' }}>Comprobante de Pago</h4>
                  {(estadoFacturacion?.adjuntoComprobante || estadoFacturacion?.comprobantePago) ? (
                    <Button
                      className="btn btn-success" 
                      onClick={() => {
                        setArchivoSeleccionado({
                          url: `${process.env.REACT_APP_ADJUNTOS_URL}/Comprobantes/${estadoFacturacion.adjuntoComprobante || estadoFacturacion.comprobantePago}`,
                          nombre: estadoFacturacion.adjuntoComprobante || estadoFacturacion.comprobantePago,
                          tipo: 'Comprobante',
                          idEstadoFacturacion: estadoFacturacion.idEstadoFacturacionTecnico || estadoFacturacion.idEstadoFacturacionMedico
                        });
                        setMostrarModalAdjuntos(true);
                      }}
                    >
                      Ver Comprobante de Pago
                    </Button>
                  ) : (
                    <p style={{ color: '#64748b', fontSize: '14px' }}>No hay comprobante disponible</p>
                  )}
                </div>
              </div>
            )}

            {turnosDetalle.length > 0 && (
              <NotificacionesPanel 
                notificaciones={notificaciones}
                mensaje={mensaje}
                setMensaje={setMensaje}
                onEnviarMensaje={handleEnviarMensaje}
                isAdmin={isAdmin}
              />
            )}
          </>
        )}

        {(vistaActiva === 'liquidaciones-tecnicos' || vistaActiva === 'liquidaciones-medicos') && isAdmin && (
          <>
            <div className="filtros-container">
              <div className="form-group">
                <label>Mes</label>
                <select value={mes} onChange={(e) => setMes(parseInt(e.target.value))} className="form-control">
                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>{getMesNombre(i + 1)}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Año</label>
                <select value={anio} onChange={(e) => setAnio(parseInt(e.target.value))} className="form-control">
                  {Array.from({ length: 9 }, (_, i) => 2018 + i).map(y => (
                    <option key={y} value={y}>{y}</option>
                  ))}
                </select>
              </div>
              <div className="form-group button-group">
                <Button onClick={handleBuscar} className="btn btn-primary">Buscar Liquidaciones</Button>
                <Button onClick={handleExportar} className="btn btn-success" disabled={turnos.length === 0}>Exportar Excel</Button>
              </div>
            </div>

            {turnos.length > 0 && (
              <TablaFacturacionTecnicos 
                datos={turnos}
                titulo="Liquidaciones"
                onVerAdjuntos={handleVerAdjuntos}
                esMedicos={!esTecnicos()}
                mes={mes}
                anio={anio}
              />
            )}
          </>
        )}
      </div>

      {mostrarModalAdjuntos && archivoSeleccionado && (
        <Modal show onHide={handleCerrarModalAdjuntos} size="xl" className="sugi-file-dialog">
<Modal.Header closeButton><Modal.Title>{archivoSeleccionado.tipo}</Modal.Title></Modal.Header>
<Modal.Body>
              {archivoSeleccionado.nombre?.toLowerCase().endsWith('.pdf') ? (
                <iframe src={archivoSeleccionado.url} title={archivoSeleccionado.tipo} />
              ) : (
                <img src={archivoSeleccionado.url} alt={archivoSeleccionado.tipo} />
              )}
            </Modal.Body>
<Modal.Footer>
              <Button href={archivoSeleccionado.url} target="_blank" rel="noopener noreferrer" className="btn btn-primary">Descargar</Button>
              {(isAdmin || archivoSeleccionado.tipo === 'Factura') && (
                <Button onClick={() => handleEliminarArchivo(archivoSeleccionado.tipo)} className="btn btn-danger">Eliminar</Button>
              )}
              <Button onClick={handleCerrarModalAdjuntos} className="btn btn-secondary">Cerrar</Button>
            </Modal.Footer>
</Modal>
      )}

      {mostrarModalSubida && (
        <Modal show onHide={() => setMostrarModalSubida(false)} size="sm">
<Modal.Header closeButton><Modal.Title>Subir {tipoSubida === 'factura' ? 'Factura' : 'Comprobante'}</Modal.Title></Modal.Header>
<Modal.Body>
              <div className="mb-3">
                <label className="form-label">Seleccionar archivo</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={handleSubirArchivoLiquidacion}
                  accept=".pdf,.jpg,.jpeg,.png"
                />
              </div>
            </Modal.Body>
<Modal.Footer>
              <Button onClick={() => setMostrarModalSubida(false)} className="btn btn-secondary">Cancelar</Button>
            </Modal.Footer>
</Modal>
      )}

      <Footer />
      <ToastContainer toast={toast} onClose={() => setToast(null)} />
    </div>
  );
};

export default FacturacionTecnicos;
